<main id="db-wrapper" class="bg-light">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation *ngIf="userRole=='Administrator'"></app-only-admin-navigation>
      <app-admin-nav *ngIf="userRole!='Administrator'"></app-admin-nav>
    </div>

    <div class="container-fluid py-5" >
      <div class="row px-4 py-3">
        <div class="col-lg-12" >
          <app-linktree-top ></app-linktree-top>
        </div>
      </div>
      <div class="container">
        <div class="row no-gutters">

          <div class="col-lg-8">
           <h2 >
             {{"socialIcons" | translate}}
           </h2>
           <div class="container" *ngIf="loading">
             <div class="row">
               <div class="col-lg-12">
                    <app-form-spinner></app-form-spinner>
               </div>
             </div>
           </div>
           <div class="card mb-4 card-hover py-8  rounded-4 " *ngIf="!loading">
             <h2 class="mt-n4 p-4">
              {{"beIconic" | translate}}
             </h2>
             <span class="p-4">
              {{'addIconsLinking' | translate}}
             </span>
            <div class="card-body">
             <button type="button" class="btn btn-primary py-2 rounded-4  mb-4"  data-bs-toggle="modal" data-bs-target="#exampleModalToggle"><h4 class="text-white">
             {{'addIcon' | translate}}
            </h4></button>
             <div class="d-flex justify-content-between " *ngFor="let item of socialLink">
               <div class="d-grid mb-2">
                 <button class="btn bg-light">{{item.linkType}}</button>
               </div>
               <div class="d-flex mb-2 ms-2">
                 <button class="btn  btn-icon bg-light px-3 me-2" (click)="singleLink(item)" data-bs-toggle="modal" data-bs-target="#exampleModal"><i class="fa-solid fa-pencil"></i></button>
                 <button class="btn  btn-icon bg-light px-3" (click)="onDelete(item.id)"><i class="fa-regular fa-trash-can"></i></button>
               </div>
             </div>

           </div>
           </div>
           <app-account-setting></app-account-setting>
          </div>
          <div class="col-lg-4 mb-10 text-center">
            <div class="d-flex justify-content-center my-5">
              <div class="card rounded-4  black-border card-scrollable" style="width: 250px;">
                <app-theme4 [loading]="loading" [user]="user1" [Links]="linksData" [socialLink]="socialLink"></app-theme4>
               </div>
            </div>
          </div>
         </div>
       </div>
     </div>
  </section>
</main>







<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex justify-content-between">
        <button class="btn me-20" data-bs-target="#exampleModalToggle" data-bs-toggle="modal" data-bs-dismiss="modal"><i class="fa-solid fa-chevron-left"></i></button>
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="showUpdate">{{'updateUrl' | translate}}</h1>
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="!showUpdate">
          {{"enterUrl" | translate}}
        </h1>
      </div>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form  [formGroup]="Links" (ngSubmit)="showUpdate ? onUpdate() : onSubmitLinks()">
        <div class="row no-gutters">
           <div class="col-lg-12">
            <input type="text"  class="form-control my-2 py-3 rounded-2"  formControlName="link">
            <div class="error-message text-danger" *ngIf="Links.get('link')?.invalid && Links.get('link')?.touched">
              <ng-container *ngIf="Links.get('link')?.hasError('required')" class="text-danger">{{mess}} {{'isRequired' | translate}}</ng-container>
            </div>
          </div>
          <div class="col-lg-12 text-center d-grid" *ngIf="!showUpdate">
            <button type="submit" class="btn btn-primary px-5 rounded-4 py-2" *ngIf="!loading">
            <h3 class="text-white"><span class="pi pi-link"></span>
             {{"Add" | translate}}
            </h3>
          </button>
          <button  class="btn btn-primary px-5 rounded-4 py-2" *ngIf="loading">
           <app-button-spinner></app-button-spinner>
          </button>
          </div>
          <div class="col-lg-12 text-center d-grid" *ngIf="showUpdate">
            <button type="submit" class="btn btn-success px-5 rounded-4 py-2" *ngIf="!loading"><h3 class="text-white"><span class="pi pi-link"></span>
             {{"Update" | translate}}
            </h3></button>
            <button  class="btn btn-primary px-5 rounded-4 py-2" *ngIf="loading">
              <app-button-spinner></app-button-spinner>
             </button>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">

    </div>
  </div>
</div>
</div>


<div class="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header text-center">
        <h3 class="modal-title " id="exampleModalToggleLabel">
          {{"addIcon" | translate}}
        </h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body card-scrollable-icons">
        <div class="row">
          <div class="col-12" *ngFor="let platform of socialMediaPlatforms">
           <div class="d-grid">
            <button class="btn btn-light px-5 py-3 mb-2 d-flex justify-content-start" data-bs-target="#exampleModal" data-bs-toggle="modal" data-bs-dismiss="modal" (click)="selectPlatform(platform.name)">
              <i [class]="platform.icon" style="font-size:25px;"></i> <h4 class="text-md fw-bold ms-4">{{ platform.name }}</h4>
            </button>
           </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="Addmail" tabindex="-1" aria-labelledby="AddmailLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex justify-content-between">
          <h1 class="modal-title fs-5" id="exampleModalLabel" >
            {{"addEmail" | translate}}
          </h1>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form  [formGroup]="MailForm" (ngSubmit)="AddEmail()">
          <div class="row no-gutters">

             <div class="col-lg-12">
              <input type="email"  class="form-control my-2 py-3 rounded-2"  formControlName="email">
              <div class="error-message text-danger" *ngIf="MailForm.get('email')?.invalid && MailForm.get('email')?.touched">
                <ng-container *ngIf="MailForm.get('email')?.hasError('required')" class="text-danger">
                  {{"EMAIL_REQUIRED" | translate}}
                </ng-container>
                <ng-container *ngIf="MailForm.get('email')?.hasError('email')" class="text-danger">
                  {{'EMAIL_INVALID' | translate}}
                </ng-container>
              </div>
            </div>
            <div class="col-lg-12 text-center d-grid" >
              <button type="submit" class="btn btn-success px-5 rounded-4 py-2" [disabled]="MailForm.invalid"><h3 class="text-white">
                {{'Add' | translate}}
              </h3></button>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">

      </div>
    </div>
  </div>
  </div>

  <div class="d-block d-sm-block d-md-block d-lg-none d-xl-none mt-10">
    <app-bottom-nav></app-bottom-nav>
  </div>
